import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement>

/** Ikony rysowane obrysem 1.6 px, żeby były czytelne na ciemnym tle w małym rozmiarze. */
function Ikona({ children, ...props }: Props) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  )
}

export const IkonaPulpit = (props: Props) => (
  <Ikona {...props}>
    <path d="M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-3H4zM14 7h6V4h-6z" />
  </Ikona>
)

export const IkonaKalendarz = (props: Props) => (
  <Ikona {...props}>
    <rect x="3" y="5" width="18" height="16" rx="3" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </Ikona>
)

export const IkonaKoszty = (props: Props) => (
  <Ikona {...props}>
    <path d="M4 6h16M4 12h16M4 18h10" />
  </Ikona>
)

export const IkonaWiecej = (props: Props) => (
  <Ikona {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" />
  </Ikona>
)

export const IkonaPlus = (props: Props) => (
  <Ikona {...props}>
    <path d="M12 5v14M5 12h14" />
  </Ikona>
)

export const IkonaPtaszek = (props: Props) => (
  <Ikona {...props}>
    <path d="M4 12.5 9.5 18 20 7" />
  </Ikona>
)

export const IkonaKrzyzyk = (props: Props) => (
  <Ikona {...props}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Ikona>
)

export const IkonaSzukaj = (props: Props) => (
  <Ikona {...props}>
    <circle cx="11" cy="11" r="6" />
    <path d="m16 16 4 4" />
  </Ikona>
)

export const IkonaStrzalkaLewo = (props: Props) => (
  <Ikona {...props}>
    <path d="M15 5l-7 7 7 7" />
  </Ikona>
)

export const IkonaStrzalkaPrawo = (props: Props) => (
  <Ikona {...props}>
    <path d="M9 5l7 7-7 7" />
  </Ikona>
)

export const IkonaKosz = (props: Props) => (
  <Ikona {...props}>
    <path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" />
  </Ikona>
)

export const IkonaPobierz = (props: Props) => (
  <Ikona {...props}>
    <path d="M12 4v11m0 0 4-4m-4 4-4-4M5 19h14" />
  </Ikona>
)
